module.exports = __webpack_public_path__ + "static/media/resources-mobile.2a50322e.svg";